import { render } from "./premium-label.vue?vue&type=template&id=0fc1c516&ts=true"
import script from "./premium-label.ts?vue&type=script&lang=ts&external"
export * from "./premium-label.ts?vue&type=script&lang=ts&external"

import "./premium-label.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__